import Axios from 'axios';
import { Input, Result } from './consultar-cursos-complementares.types';

export const consultarCursosComplementaresService = async ({ urlBase, token }: Input): Promise<Result> => {
  const url = `${urlBase}/v3/cursos-complementares`;
  const authorization = `Bearer ${token}`;

  const { data } = await Axios.get<Result>(url, {
    headers: { authorization },
  });

  return data;
};
